<template>

  <div class="p-grid p-pb-6">
    <div class="p-col-12 p-pt-1 p-pb-1">
      <h2>
        <a href="#/after-sales">{{ $t('afterSales.title') }}</a> <img class="p-pl-2 p-pr-3"
          src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')" />
        <a href="#/after-sales/search-serial">{{ $t('afterSales.search_serial.title') }}</a> <img class="p-pl-2 p-pr-2"
          src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')" />
        {{ numeroMatricola }}
      </h2>

      <div class="irinox-form after-sales p-mt-4">

        <h4 style="">
          {{ $t('afterSales.search_serial.bom.title') }}: {{ codice }}
        </h4>

        <div v-if="nodes?.length>0">
          <TreeTable :value="nodes" style="min-width: 800px" 
                v-model:expandedKeys="expandedKeys"
                sortField="codiceFiglio" :sortOrder="1" 
              >


            <Column field="codiceFiglio" :header="$t('afterSales.search_serial.bom.col_codiceFiglio')" expander>
              <template #body="slotProps">
                  <span :class="[{ 'bom-parent': isParent(slotProps.node), 'not-in-catalogue': !slotProps.node.data.existsInCatalogue }]">
                    <!-- {{ slotProps.node.data.codiceFiglio }} <i class="pi pi-clipboard p-ml-2" @click="$functions.copy(slotProps.node.data.codiceFiglio)" style="cursor: pointer; font-size: .8rem;"/> -->
                    {{ slotProps.node.data.codiceFiglio }}
                  </span>
              </template>
            </Column>

            <Column field="posizioneEsploso" :header="$t('afterSales.search_serial.bom.col_posizioneEsploso')" style="width: 120px;">
              <template #body="slotProps">
                <div class="p-d-flex p-ai-center p-jc-between">
                  <span :class="[{ 'bom-parent': isParent(slotProps.node), 'not-in-catalogue': !slotProps.node.data.existsInCatalogue }]">
                    {{ slotProps.node.data.posizioneEsploso }} 
                  </span>
                  <i v-if="slotProps.node.data.posizioneEsploso!='' && isSpDocPresent && slotProps.node.data.pdfPages?.length > 0" class="pi pi-search" style="color: #002445; font-size: 1em; cursor: pointer;" @click="openDoc(slotProps.node.data)"></i>
                </div>
              </template>
            </Column>

            <Column field="descrizione" :header="$t('afterSales.search_serial.bom.col_descrizione')">
              <template #body="slotProps">
                <span :class="[{ 'bom-parent': isParent(slotProps.node), 'not-in-catalogue': !slotProps.node.data.existsInCatalogue }]">
                  {{ slotProps.node.data.descrizione }}
                </span>
              </template>
            </Column>

            <Column field="quantitàImpegnata" :header="$t('afterSales.search_serial.bom.col_quantitaImpegnata')" style="width: 170px; text-align: right;">
              <template #body="slotProps">
                <span :class="[{ 'bom-parent': isParent(slotProps.node), 'not-in-catalogue': !slotProps.node.data.existsInCatalogue }]" style="text-transform: uppercase;">
                  {{ slotProps.node.data.quantitàImpegnata }}
                </span>
              </template>
            </Column>

            <Column :header="$t('afterSales.search_serial.bom.col_prezzo')" style="width: 150px; text-align: right;">
              <template #body="slotProps">
                <span :class="[{ 'bom-parent': isParent(slotProps.node), 'not-in-catalogue': !slotProps.node.data.existsInCatalogue }]">
                  {{ slotProps.node.data.prezzo != null ? $n(slotProps.node.data.prezzo, 'money') : '' }}
                  {{ slotProps.node.data.prezzo != null ? (slotProps.node.data.currency === 'EUR' ? '€' : '$') : '' }}
                </span>
              </template>
            </Column>

            <Column style="width: 100px; text-align: right;">
              <template #body="slotProps">
                <span :class="[{ 'bom-parent': isParent(slotProps.node), 'not-in-catalogue': !slotProps.node.data.existsInCatalogue }]">
                  <i v-if="slotProps.node.data.existsInCatalogue" class="pi pi-cart-plus" style="color: #002445; font-size: 1.4em; cursor: pointer;" @click="openPreorder(slotProps.node.data)"></i>
                </span>
              </template>
            </Column>


          </TreeTable>
        </div>
        <div v-else class="p-mt-4 "> 
          {{ $t('afterSales.search_serial.bom.empty_list') }}
        </div>  

      </div>

    </div>
  </div>

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('afterSales.search_serial.dialog_error')"
    :life="3000" @update:visible="dialog.error = $event" />

  <SparePartsPreorder :visible="dialog.preorder" :sparePart="selectedSparePart"
    @update:visible="dialog.preorder = $event" />

</template>

<script>
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import AfterSalesService from '../../service/AfterSalesService';
import SparePartsPreorder from './spareParts/SparePartsPreorder.vue';

export default {
  components: {
    IrinoxDialogDark,
    SparePartsPreorder,
  },
  data() {
    return {
      dialog: {
        error: false,
        preorder: false,
      },
      numeroMatricola: this.$route.params.serialNumber,
      codice: this.$route.params.productCode,
      bom: {},
      nodes: null,
      expandedKeys: {},
      selectedSparePart: null,
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      docTreeRaw: 'afterSales/docTreeRaw',
      role: 'userdata/role',
    }),
    isSpDocPresent() {
      return this.bom.header.spDocsId != null;
    }
  },
  watch: {
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() {
    this.searchBom();
  },
  unmounted() {
  },
  methods: {
    searchBom() {
      this.bom = {};
      this.afterSalesService.getDocsRmBom(this.personaltoken, this.numeroMatricola, this.codice, this.$functions.language(this.$i18n.locale))
        .then((data) => {
          if (data.code == "200") {
            this.bom = data.body;
            this.nodes = this.buildBOMForest(this.bom.components);
            this.nodes = this.pruneByCatalogue(this.nodes);
            this.expandAll();
          } else {
            console.error(JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    buildBOMForest(rows, rootPadre = null) {
      const byPadre = new Map();
      const padri = new Set();
      const figli = new Set();

      for (const r of rows) {
        padri.add(r.codicePadre);
        figli.add(r.codiceFiglio);
        if (!byPadre.has(r.codicePadre)) byPadre.set(r.codicePadre, []);
        byPadre.get(r.codicePadre).push(r);
      }

      const roots = rootPadre
        ? [rootPadre]
        : [...padri].filter(p => !figli.has(p)); // possono essere più di 1

      const visiting = new Set();

      const buildNodes = (padre) => (byPadre.get(padre) ?? []).map((row) => {
        const key = `${row.codicePadre}__${row.codiceFiglio}`; // chiave unica per il nodo, utile per evitare cicli infiniti
        const cycleKey = `${row.codicePadre}__${row.codiceFiglio}`;
        if (visiting.has(cycleKey)) return { key, data: row, children: [] };

        visiting.add(cycleKey);
        const node = { key, data: row, children: buildNodes(row.codiceFiglio) };
        visiting.delete(cycleKey);
        return node;
      });

      // ritorna una lista di root nodes (foresta)
      return roots.flatMap(r => buildNodes(r));
    },
    pruneByCatalogue(nodes) {
      const pruneNode = (node) => {
        const children = Array.isArray(node.children) ? node.children : [];

        // prima poto ricorsivamente i figli
        const prunedChildren = children
          .map(pruneNode)
          .filter(Boolean);

        const exists = node?.data?.existsInCatalogue === true;

        // regola: foglia non a catalogo -> via
        // regola: padre non a catalogo con 0 figli rimasti -> via
        // regola: padre non a catalogo con figli rimasti -> resta
        if (!exists && prunedChildren.length === 0) {
          return null;
        }

        // ritorno nodo aggiornato (senza mutare l'originale)
        return {
          ...node,
          children: prunedChildren,
        };
      };

      return (nodes || [])
        .map(pruneNode)
        .filter(Boolean);
    },
    isParent(node) {
      return Array.isArray(node.children) && node.children.length > 0;
    },
    expandAll() {
      const keys = {};
      const visit = (arr) => {
        (arr || []).forEach((n) => {
          if (n.children && n.children.length) {
            keys[n.key] = true;      // espandi questo nodo
            visit(n.children);       // e continua sotto
          }
        });
      };
      visit(this.nodes);
      this.expandedKeys = keys;
    },
    collapseAll() {
      this.expandedKeys = {};
    },
    openDoc(data) {
      this.$router.push({ name: 'after-sales-spare-parts', params: { docTreeId: this.bom.header.docTreeId, table: this.$functions.crypt("table", this.bom.header.spDocsId+"|||"+data.pdfPages[0]) } });
    },
    openPreorder(data) {
      this.selectedSparePart = {
        code: data.codiceFiglio,
        description: data.descrizione,
        price: data.prezzo,
        currency: data.currency,
        position: data.posizioneEsploso,
      };
      this.dialog.preorder = true;
    },
  },

}
</script>

<style scoped>


</style>